<template>
  <div class="coming-soon">
    <img src="/img/comingsoon.png" :alt="$t('Coming Soon')">
    <slot></slot>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';

@Component()
export default class ComingSoon extends Vue {

}
</script>

<style scoped lang="postcss">
@import 'core/shared/styles';

.coming-soon {
  @apply --body;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin: var(--spacingLg) 0;

  & img {
    width: 100%;
    max-width: 32rem;
    height: 30rem;
    margin-bottom: var(--spacingLg);
  }
}
</style>
